/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Address,
  Contract,
  ContractState,
  TestContractResult,
  HexString,
  ContractFactory,
  EventSubscribeOptions,
  EventSubscription,
  CallContractParams,
  CallContractResult,
  TestContractParams,
  ContractEvent,
  subscribeContractEvent,
  subscribeContractEvents,
  testMethod,
  callMethod,
  multicallMethods,
  fetchContractState,
  Asset,
  ContractInstance,
  getContractEventsCurrentCount,
  TestContractParamsWithoutMaps,
  TestContractResultWithoutMaps,
  SignExecuteContractMethodParams,
  SignExecuteScriptTxResult,
  signExecuteMethod,
  addStdIdToFields,
  encodeContractFields,
  Narrow,
} from "@alephium/web3";
import { default as RocketRangeContractJson } from "../rocket_range/RocketRange.ral.json";
import { getContractByCodeHash, registerContract } from "./contracts";
import {
  LeaderboardEntry,
  LeaderboardPeriodicTop,
  RocketRangeGameInstance,
  RocketRangeGameSettings,
  RocketRangeOracleValue,
  RocketRangeUserBet,
  UpgradableSettings,
  AllStructs,
} from "./types";
import { RalphMap } from "@alephium/web3";

// Custom types for the contract
export namespace RocketRangeTypes {
  export type Fields = {
    oracle: HexString;
    leaderboard: HexString;
    upgradableSettings: UpgradableSettings;
    gameSettings: RocketRangeGameSettings;
    latestRoundId: bigint;
    lastPrice: bigint;
    nextRoundPotBootstrap: bigint;
    protocolFeeTotal: bigint;
  };

  export type State = ContractState<Fields>;

  export type ChangeOwnerCommenceEvent = ContractEvent<{
    owner: Address;
    changeOwner: Address;
  }>;
  export type ChangeOwnerApplyEvent = ContractEvent<{
    owner: Address;
    changeOwner: Address;
  }>;
  export type MigrateCommenceEvent = ContractEvent<{
    owner: Address;
    changeCode: HexString;
  }>;
  export type MigrateApplyEvent = ContractEvent<{
    owner: Address;
    changeCode: HexString;
  }>;
  export type MigrateWithFieldsApplyEvent = ContractEvent<{
    owner: Address;
    changeCode: HexString;
    changeImmFieldsEncoded: HexString;
    changeMutFieldsEncoded: HexString;
  }>;
  export type NewRoundCreatedEvent = ContractEvent<{
    roundId: bigint;
    betOpenTime: bigint;
    betCloseTime: bigint;
    gameEndTime: bigint;
    initialPot: bigint;
  }>;
  export type BetPlacedEvent = ContractEvent<{
    user: Address;
    roundId: bigint;
    amount: bigint;
    betChoice: bigint;
  }>;
  export type RoundSettledEvent = ContractEvent<{
    roundId: bigint;
    result: bigint;
    totalPotSize: bigint;
    potFeesClaimed: bigint;
  }>;
  export type UserPayoutEvent = ContractEvent<{
    user: Address;
    roundId: bigint;
    payoutAmount: bigint;
  }>;
  export type OpenPriceUpdatedEvent = ContractEvent<{
    roundId: bigint;
    price: bigint;
    timestamp: bigint;
  }>;
  export type ClosePriceUpdatedEvent = ContractEvent<{
    roundId: bigint;
    price: bigint;
    timestamp: bigint;
  }>;
  export type ProtocolFeeClaimedEvent = ContractEvent<{
    caller: Address;
    amount: bigint;
  }>;
  export type NextRoundPotToppedUpEvent = ContractEvent<{
    caller: Address;
    amount: bigint;
  }>;

  export interface CallMethodTable {
    changeOwner: {
      params: CallContractParams<{ changeOwner: Address }>;
      result: CallContractResult<null>;
    };
    migrate: {
      params: CallContractParams<{ changeCode: HexString }>;
      result: CallContractResult<null>;
    };
    changeOwnerApply: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<null>;
    };
    migrateApply: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<null>;
    };
    migrateWithFieldsApply: {
      params: CallContractParams<{
        newImmFieldsEncoded: HexString;
        newMutFieldsEncoded: HexString;
      }>;
      result: CallContractResult<null>;
    };
    resetUpgrade: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<null>;
    };
    getUpgradeDelay: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<bigint>;
    };
    getOwner: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<Address>;
    };
    getNewOwner: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<Address>;
    };
    getUpgradeCommenced: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<bigint>;
    };
    getNewCode: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<HexString>;
    };
    resetFields: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<null>;
    };
    assertOnlyOwner: {
      params: CallContractParams<{ caller: Address }>;
      result: CallContractResult<null>;
    };
    assertUpgradeNotPending: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<null>;
    };
    assertUpgradeDelayElapsed: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<null>;
    };
    createNewRound: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<[bigint, RocketRangeGameInstance]>;
    };
    placeBet: {
      params: CallContractParams<{
        caller: Address;
        roundId: bigint;
        amount: bigint;
        betChoice: bigint;
      }>;
      result: CallContractResult<null>;
    };
    claimUser: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<null>;
    };
    settleUserBets: {
      params: CallContractParams<{ user: Address }>;
      result: CallContractResult<[boolean, RocketRangeUserBet]>;
    };
    payoutUser: {
      params: CallContractParams<{
        userBet: RocketRangeUserBet;
        round: RocketRangeGameInstance;
      }>;
      result: CallContractResult<[RocketRangeUserBet, bigint]>;
    };
    calculateWin: {
      params: CallContractParams<{
        userBetSize: bigint;
        userBetChoice: bigint;
        round: RocketRangeGameInstance;
      }>;
      result: CallContractResult<bigint>;
    };
    updateOpenPrice: {
      params: CallContractParams<{ roundId: bigint }>;
      result: CallContractResult<[bigint, RocketRangeGameInstance]>;
    };
    setOpenPrice: {
      params: CallContractParams<{ roundId: bigint }>;
      result: CallContractResult<RocketRangeGameInstance>;
    };
    setClosePrice: {
      params: CallContractParams<{ roundId: bigint }>;
      result: CallContractResult<boolean>;
    };
    claimProtocolFee: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<bigint>;
    };
    topUpNextRoundPot: {
      params: CallContractParams<{ amount: bigint }>;
      result: CallContractResult<null>;
    };
    updateGameSettings: {
      params: CallContractParams<{ newGameSettings: RocketRangeGameSettings }>;
      result: CallContractResult<null>;
    };
    updateLeaderboard: {
      params: CallContractParams<{ newLeaderboard: HexString }>;
      result: CallContractResult<null>;
    };
    assertPaused: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<null>;
    };
    loadGameInstance: {
      params: CallContractParams<{ roundId: bigint }>;
      result: CallContractResult<[boolean, RocketRangeGameInstance]>;
    };
    loadUserBet: {
      params: CallContractParams<{ user: Address }>;
      result: CallContractResult<[boolean, RocketRangeUserBet]>;
    };
  }
  export type CallMethodParams<T extends keyof CallMethodTable> =
    CallMethodTable[T]["params"];
  export type CallMethodResult<T extends keyof CallMethodTable> =
    CallMethodTable[T]["result"];
  export type MultiCallParams = Partial<{
    [Name in keyof CallMethodTable]: CallMethodTable[Name]["params"];
  }>;
  export type MultiCallResults<T extends MultiCallParams> = {
    [MaybeName in keyof T]: MaybeName extends keyof CallMethodTable
      ? CallMethodTable[MaybeName]["result"]
      : undefined;
  };
  export type MulticallReturnType<Callss extends MultiCallParams[]> = {
    [index in keyof Callss]: MultiCallResults<Callss[index]>;
  };

  export interface SignExecuteMethodTable {
    changeOwner: {
      params: SignExecuteContractMethodParams<{ changeOwner: Address }>;
      result: SignExecuteScriptTxResult;
    };
    migrate: {
      params: SignExecuteContractMethodParams<{ changeCode: HexString }>;
      result: SignExecuteScriptTxResult;
    };
    changeOwnerApply: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    migrateApply: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    migrateWithFieldsApply: {
      params: SignExecuteContractMethodParams<{
        newImmFieldsEncoded: HexString;
        newMutFieldsEncoded: HexString;
      }>;
      result: SignExecuteScriptTxResult;
    };
    resetUpgrade: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    getUpgradeDelay: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    getOwner: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    getNewOwner: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    getUpgradeCommenced: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    getNewCode: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    resetFields: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    assertOnlyOwner: {
      params: SignExecuteContractMethodParams<{ caller: Address }>;
      result: SignExecuteScriptTxResult;
    };
    assertUpgradeNotPending: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    assertUpgradeDelayElapsed: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    createNewRound: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    placeBet: {
      params: SignExecuteContractMethodParams<{
        caller: Address;
        roundId: bigint;
        amount: bigint;
        betChoice: bigint;
      }>;
      result: SignExecuteScriptTxResult;
    };
    claimUser: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    settleUserBets: {
      params: SignExecuteContractMethodParams<{ user: Address }>;
      result: SignExecuteScriptTxResult;
    };
    payoutUser: {
      params: SignExecuteContractMethodParams<{
        userBet: RocketRangeUserBet;
        round: RocketRangeGameInstance;
      }>;
      result: SignExecuteScriptTxResult;
    };
    calculateWin: {
      params: SignExecuteContractMethodParams<{
        userBetSize: bigint;
        userBetChoice: bigint;
        round: RocketRangeGameInstance;
      }>;
      result: SignExecuteScriptTxResult;
    };
    updateOpenPrice: {
      params: SignExecuteContractMethodParams<{ roundId: bigint }>;
      result: SignExecuteScriptTxResult;
    };
    setOpenPrice: {
      params: SignExecuteContractMethodParams<{ roundId: bigint }>;
      result: SignExecuteScriptTxResult;
    };
    setClosePrice: {
      params: SignExecuteContractMethodParams<{ roundId: bigint }>;
      result: SignExecuteScriptTxResult;
    };
    claimProtocolFee: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    topUpNextRoundPot: {
      params: SignExecuteContractMethodParams<{ amount: bigint }>;
      result: SignExecuteScriptTxResult;
    };
    updateGameSettings: {
      params: SignExecuteContractMethodParams<{
        newGameSettings: RocketRangeGameSettings;
      }>;
      result: SignExecuteScriptTxResult;
    };
    updateLeaderboard: {
      params: SignExecuteContractMethodParams<{ newLeaderboard: HexString }>;
      result: SignExecuteScriptTxResult;
    };
    assertPaused: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    loadGameInstance: {
      params: SignExecuteContractMethodParams<{ roundId: bigint }>;
      result: SignExecuteScriptTxResult;
    };
    loadUserBet: {
      params: SignExecuteContractMethodParams<{ user: Address }>;
      result: SignExecuteScriptTxResult;
    };
  }
  export type SignExecuteMethodParams<T extends keyof SignExecuteMethodTable> =
    SignExecuteMethodTable[T]["params"];
  export type SignExecuteMethodResult<T extends keyof SignExecuteMethodTable> =
    SignExecuteMethodTable[T]["result"];

  export type Maps = {
    gameInstanceCollection?: Map<bigint, RocketRangeGameInstance>;
    userBetCollection?: Map<Address, RocketRangeUserBet>;
  };
}

class Factory extends ContractFactory<
  RocketRangeInstance,
  RocketRangeTypes.Fields
> {
  encodeFields(fields: RocketRangeTypes.Fields) {
    return encodeContractFields(
      addStdIdToFields(this.contract, fields),
      this.contract.fieldsSig,
      AllStructs
    );
  }

  eventIndex = {
    ChangeOwnerCommence: 0,
    ChangeOwnerApply: 1,
    MigrateCommence: 2,
    MigrateApply: 3,
    MigrateWithFieldsApply: 4,
    NewRoundCreated: 5,
    BetPlaced: 6,
    RoundSettled: 7,
    UserPayout: 8,
    OpenPriceUpdated: 9,
    ClosePriceUpdated: 10,
    ProtocolFeeClaimed: 11,
    NextRoundPotToppedUp: 12,
  };
  consts = {
    ORACLE_TOLERANCE_MS: BigInt("7200000"),
    UpgradeErrorCodes: {
      Forbidden: BigInt("13000"),
      UpgradePending: BigInt("13001"),
      UpgradeNotPending: BigInt("13002"),
      UpgradeDelayNotExpired: BigInt("13003"),
      MigrateNotPending: BigInt("13004"),
      MigrateWithFieldsNotPending: BigInt("13005"),
      ChangeOwnerNotPending: BigInt("13006"),
    },
    ErrorCodes: {
      Paused: BigInt("0"),
      RoundAlreadyExists: BigInt("1"),
      RoundDoesNotExist: BigInt("2"),
      NotEnoughAlphToStartNewRound: BigInt("3"),
      CanNotUpdatePriceDueToGameRules: BigInt("4"),
      InvalidBetChoice: BigInt("5"),
      AlreadyPlacedTwoBets: BigInt("6"),
      OpenPriceNotSet: BigInt("7"),
      OracleError: BigInt("8"),
    },
  };

  at(address: string): RocketRangeInstance {
    return new RocketRangeInstance(address);
  }

  tests = {
    changeOwner: async (
      params: TestContractParams<
        RocketRangeTypes.Fields,
        { changeOwner: Address },
        RocketRangeTypes.Maps
      >
    ): Promise<TestContractResult<null, RocketRangeTypes.Maps>> => {
      return testMethod(this, "changeOwner", params, getContractByCodeHash);
    },
    migrate: async (
      params: TestContractParams<
        RocketRangeTypes.Fields,
        { changeCode: HexString },
        RocketRangeTypes.Maps
      >
    ): Promise<TestContractResult<null, RocketRangeTypes.Maps>> => {
      return testMethod(this, "migrate", params, getContractByCodeHash);
    },
    changeOwnerApply: async (
      params: Omit<
        TestContractParams<
          RocketRangeTypes.Fields,
          never,
          RocketRangeTypes.Maps
        >,
        "testArgs"
      >
    ): Promise<TestContractResult<null, RocketRangeTypes.Maps>> => {
      return testMethod(
        this,
        "changeOwnerApply",
        params,
        getContractByCodeHash
      );
    },
    migrateApply: async (
      params: Omit<
        TestContractParams<
          RocketRangeTypes.Fields,
          never,
          RocketRangeTypes.Maps
        >,
        "testArgs"
      >
    ): Promise<TestContractResult<null, RocketRangeTypes.Maps>> => {
      return testMethod(this, "migrateApply", params, getContractByCodeHash);
    },
    migrateWithFieldsApply: async (
      params: TestContractParams<
        RocketRangeTypes.Fields,
        { newImmFieldsEncoded: HexString; newMutFieldsEncoded: HexString },
        RocketRangeTypes.Maps
      >
    ): Promise<TestContractResult<null, RocketRangeTypes.Maps>> => {
      return testMethod(
        this,
        "migrateWithFieldsApply",
        params,
        getContractByCodeHash
      );
    },
    resetUpgrade: async (
      params: Omit<
        TestContractParams<
          RocketRangeTypes.Fields,
          never,
          RocketRangeTypes.Maps
        >,
        "testArgs"
      >
    ): Promise<TestContractResult<null, RocketRangeTypes.Maps>> => {
      return testMethod(this, "resetUpgrade", params, getContractByCodeHash);
    },
    getUpgradeDelay: async (
      params: Omit<
        TestContractParams<
          RocketRangeTypes.Fields,
          never,
          RocketRangeTypes.Maps
        >,
        "testArgs"
      >
    ): Promise<TestContractResult<bigint, RocketRangeTypes.Maps>> => {
      return testMethod(this, "getUpgradeDelay", params, getContractByCodeHash);
    },
    getOwner: async (
      params: Omit<
        TestContractParams<
          RocketRangeTypes.Fields,
          never,
          RocketRangeTypes.Maps
        >,
        "testArgs"
      >
    ): Promise<TestContractResult<Address, RocketRangeTypes.Maps>> => {
      return testMethod(this, "getOwner", params, getContractByCodeHash);
    },
    getNewOwner: async (
      params: Omit<
        TestContractParams<
          RocketRangeTypes.Fields,
          never,
          RocketRangeTypes.Maps
        >,
        "testArgs"
      >
    ): Promise<TestContractResult<Address, RocketRangeTypes.Maps>> => {
      return testMethod(this, "getNewOwner", params, getContractByCodeHash);
    },
    getUpgradeCommenced: async (
      params: Omit<
        TestContractParams<
          RocketRangeTypes.Fields,
          never,
          RocketRangeTypes.Maps
        >,
        "testArgs"
      >
    ): Promise<TestContractResult<bigint, RocketRangeTypes.Maps>> => {
      return testMethod(
        this,
        "getUpgradeCommenced",
        params,
        getContractByCodeHash
      );
    },
    getNewCode: async (
      params: Omit<
        TestContractParams<
          RocketRangeTypes.Fields,
          never,
          RocketRangeTypes.Maps
        >,
        "testArgs"
      >
    ): Promise<TestContractResult<HexString, RocketRangeTypes.Maps>> => {
      return testMethod(this, "getNewCode", params, getContractByCodeHash);
    },
    resetFields: async (
      params: Omit<
        TestContractParams<
          RocketRangeTypes.Fields,
          never,
          RocketRangeTypes.Maps
        >,
        "testArgs"
      >
    ): Promise<TestContractResult<null, RocketRangeTypes.Maps>> => {
      return testMethod(this, "resetFields", params, getContractByCodeHash);
    },
    assertOnlyOwner: async (
      params: TestContractParams<
        RocketRangeTypes.Fields,
        { caller: Address },
        RocketRangeTypes.Maps
      >
    ): Promise<TestContractResult<null, RocketRangeTypes.Maps>> => {
      return testMethod(this, "assertOnlyOwner", params, getContractByCodeHash);
    },
    assertUpgradeNotPending: async (
      params: Omit<
        TestContractParams<
          RocketRangeTypes.Fields,
          never,
          RocketRangeTypes.Maps
        >,
        "testArgs"
      >
    ): Promise<TestContractResult<null, RocketRangeTypes.Maps>> => {
      return testMethod(
        this,
        "assertUpgradeNotPending",
        params,
        getContractByCodeHash
      );
    },
    assertUpgradeDelayElapsed: async (
      params: Omit<
        TestContractParams<
          RocketRangeTypes.Fields,
          never,
          RocketRangeTypes.Maps
        >,
        "testArgs"
      >
    ): Promise<TestContractResult<null, RocketRangeTypes.Maps>> => {
      return testMethod(
        this,
        "assertUpgradeDelayElapsed",
        params,
        getContractByCodeHash
      );
    },
    createNewRound: async (
      params: Omit<
        TestContractParams<
          RocketRangeTypes.Fields,
          never,
          RocketRangeTypes.Maps
        >,
        "testArgs"
      >
    ): Promise<
      TestContractResult<
        [bigint, RocketRangeGameInstance],
        RocketRangeTypes.Maps
      >
    > => {
      return testMethod(this, "createNewRound", params, getContractByCodeHash);
    },
    placeBet: async (
      params: TestContractParams<
        RocketRangeTypes.Fields,
        { caller: Address; roundId: bigint; amount: bigint; betChoice: bigint },
        RocketRangeTypes.Maps
      >
    ): Promise<TestContractResult<null, RocketRangeTypes.Maps>> => {
      return testMethod(this, "placeBet", params, getContractByCodeHash);
    },
    claimUser: async (
      params: Omit<
        TestContractParams<
          RocketRangeTypes.Fields,
          never,
          RocketRangeTypes.Maps
        >,
        "testArgs"
      >
    ): Promise<TestContractResult<null, RocketRangeTypes.Maps>> => {
      return testMethod(this, "claimUser", params, getContractByCodeHash);
    },
    settleUserBets: async (
      params: TestContractParams<
        RocketRangeTypes.Fields,
        { user: Address },
        RocketRangeTypes.Maps
      >
    ): Promise<
      TestContractResult<[boolean, RocketRangeUserBet], RocketRangeTypes.Maps>
    > => {
      return testMethod(this, "settleUserBets", params, getContractByCodeHash);
    },
    payoutUser: async (
      params: TestContractParams<
        RocketRangeTypes.Fields,
        { userBet: RocketRangeUserBet; round: RocketRangeGameInstance },
        RocketRangeTypes.Maps
      >
    ): Promise<
      TestContractResult<[RocketRangeUserBet, bigint], RocketRangeTypes.Maps>
    > => {
      return testMethod(this, "payoutUser", params, getContractByCodeHash);
    },
    calculateWin: async (
      params: TestContractParams<
        RocketRangeTypes.Fields,
        {
          userBetSize: bigint;
          userBetChoice: bigint;
          round: RocketRangeGameInstance;
        },
        RocketRangeTypes.Maps
      >
    ): Promise<TestContractResult<bigint, RocketRangeTypes.Maps>> => {
      return testMethod(this, "calculateWin", params, getContractByCodeHash);
    },
    updateOpenPrice: async (
      params: TestContractParams<
        RocketRangeTypes.Fields,
        { roundId: bigint },
        RocketRangeTypes.Maps
      >
    ): Promise<
      TestContractResult<
        [bigint, RocketRangeGameInstance],
        RocketRangeTypes.Maps
      >
    > => {
      return testMethod(this, "updateOpenPrice", params, getContractByCodeHash);
    },
    setOpenPrice: async (
      params: TestContractParams<
        RocketRangeTypes.Fields,
        { roundId: bigint },
        RocketRangeTypes.Maps
      >
    ): Promise<
      TestContractResult<RocketRangeGameInstance, RocketRangeTypes.Maps>
    > => {
      return testMethod(this, "setOpenPrice", params, getContractByCodeHash);
    },
    setClosePrice: async (
      params: TestContractParams<
        RocketRangeTypes.Fields,
        { roundId: bigint },
        RocketRangeTypes.Maps
      >
    ): Promise<TestContractResult<boolean, RocketRangeTypes.Maps>> => {
      return testMethod(this, "setClosePrice", params, getContractByCodeHash);
    },
    claimProtocolFee: async (
      params: Omit<
        TestContractParams<
          RocketRangeTypes.Fields,
          never,
          RocketRangeTypes.Maps
        >,
        "testArgs"
      >
    ): Promise<TestContractResult<bigint, RocketRangeTypes.Maps>> => {
      return testMethod(
        this,
        "claimProtocolFee",
        params,
        getContractByCodeHash
      );
    },
    topUpNextRoundPot: async (
      params: TestContractParams<
        RocketRangeTypes.Fields,
        { amount: bigint },
        RocketRangeTypes.Maps
      >
    ): Promise<TestContractResult<null, RocketRangeTypes.Maps>> => {
      return testMethod(
        this,
        "topUpNextRoundPot",
        params,
        getContractByCodeHash
      );
    },
    updateGameSettings: async (
      params: TestContractParams<
        RocketRangeTypes.Fields,
        { newGameSettings: RocketRangeGameSettings },
        RocketRangeTypes.Maps
      >
    ): Promise<TestContractResult<null, RocketRangeTypes.Maps>> => {
      return testMethod(
        this,
        "updateGameSettings",
        params,
        getContractByCodeHash
      );
    },
    updateLeaderboard: async (
      params: TestContractParams<
        RocketRangeTypes.Fields,
        { newLeaderboard: HexString },
        RocketRangeTypes.Maps
      >
    ): Promise<TestContractResult<null, RocketRangeTypes.Maps>> => {
      return testMethod(
        this,
        "updateLeaderboard",
        params,
        getContractByCodeHash
      );
    },
    assertPaused: async (
      params: Omit<
        TestContractParams<
          RocketRangeTypes.Fields,
          never,
          RocketRangeTypes.Maps
        >,
        "testArgs"
      >
    ): Promise<TestContractResult<null, RocketRangeTypes.Maps>> => {
      return testMethod(this, "assertPaused", params, getContractByCodeHash);
    },
    loadGameInstance: async (
      params: TestContractParams<
        RocketRangeTypes.Fields,
        { roundId: bigint },
        RocketRangeTypes.Maps
      >
    ): Promise<
      TestContractResult<
        [boolean, RocketRangeGameInstance],
        RocketRangeTypes.Maps
      >
    > => {
      return testMethod(
        this,
        "loadGameInstance",
        params,
        getContractByCodeHash
      );
    },
    loadUserBet: async (
      params: TestContractParams<
        RocketRangeTypes.Fields,
        { user: Address },
        RocketRangeTypes.Maps
      >
    ): Promise<
      TestContractResult<[boolean, RocketRangeUserBet], RocketRangeTypes.Maps>
    > => {
      return testMethod(this, "loadUserBet", params, getContractByCodeHash);
    },
  };

  stateForTest(
    initFields: RocketRangeTypes.Fields,
    asset?: Asset,
    address?: string,
    maps?: RocketRangeTypes.Maps
  ) {
    return this.stateForTest_(initFields, asset, address, maps);
  }
}

// Use this object to test and deploy the contract
export const RocketRange = new Factory(
  Contract.fromJson(
    RocketRangeContractJson,
    "=66-2+83=2-2+f5=2-1=1+b=1+72=1-2=2-1=1-4+d=2-1+16=1+916=2-2+a=1-3=3-1+f=2+8=1-1=3-1+3=2-2+de=2-1+f5=1+c06=2-2+cb=2+6=1-1=689-1+c=380+7a7e0214696e73657274206174206d617020706174683a2000=181-1+5=769-1+7=40+7a7e0214696e73657274206174206d617020706174683a2000=4692",
    "8249b36116966add1d1314918190ee4c622d9ee1618a890e2f0c04e513d02ee5",
    AllStructs
  )
);
registerContract(RocketRange);

// Use this class to interact with the blockchain
export class RocketRangeInstance extends ContractInstance {
  constructor(address: Address) {
    super(address);
  }

  maps = {
    gameInstanceCollection: new RalphMap<bigint, RocketRangeGameInstance>(
      RocketRange.contract,
      this.contractId,
      "gameInstanceCollection"
    ),
    userBetCollection: new RalphMap<Address, RocketRangeUserBet>(
      RocketRange.contract,
      this.contractId,
      "userBetCollection"
    ),
  };

  async fetchState(): Promise<RocketRangeTypes.State> {
    return fetchContractState(RocketRange, this);
  }

  async getContractEventsCurrentCount(): Promise<number> {
    return getContractEventsCurrentCount(this.address);
  }

  subscribeChangeOwnerCommenceEvent(
    options: EventSubscribeOptions<RocketRangeTypes.ChangeOwnerCommenceEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      RocketRange.contract,
      this,
      options,
      "ChangeOwnerCommence",
      fromCount
    );
  }

  subscribeChangeOwnerApplyEvent(
    options: EventSubscribeOptions<RocketRangeTypes.ChangeOwnerApplyEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      RocketRange.contract,
      this,
      options,
      "ChangeOwnerApply",
      fromCount
    );
  }

  subscribeMigrateCommenceEvent(
    options: EventSubscribeOptions<RocketRangeTypes.MigrateCommenceEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      RocketRange.contract,
      this,
      options,
      "MigrateCommence",
      fromCount
    );
  }

  subscribeMigrateApplyEvent(
    options: EventSubscribeOptions<RocketRangeTypes.MigrateApplyEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      RocketRange.contract,
      this,
      options,
      "MigrateApply",
      fromCount
    );
  }

  subscribeMigrateWithFieldsApplyEvent(
    options: EventSubscribeOptions<RocketRangeTypes.MigrateWithFieldsApplyEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      RocketRange.contract,
      this,
      options,
      "MigrateWithFieldsApply",
      fromCount
    );
  }

  subscribeNewRoundCreatedEvent(
    options: EventSubscribeOptions<RocketRangeTypes.NewRoundCreatedEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      RocketRange.contract,
      this,
      options,
      "NewRoundCreated",
      fromCount
    );
  }

  subscribeBetPlacedEvent(
    options: EventSubscribeOptions<RocketRangeTypes.BetPlacedEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      RocketRange.contract,
      this,
      options,
      "BetPlaced",
      fromCount
    );
  }

  subscribeRoundSettledEvent(
    options: EventSubscribeOptions<RocketRangeTypes.RoundSettledEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      RocketRange.contract,
      this,
      options,
      "RoundSettled",
      fromCount
    );
  }

  subscribeUserPayoutEvent(
    options: EventSubscribeOptions<RocketRangeTypes.UserPayoutEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      RocketRange.contract,
      this,
      options,
      "UserPayout",
      fromCount
    );
  }

  subscribeOpenPriceUpdatedEvent(
    options: EventSubscribeOptions<RocketRangeTypes.OpenPriceUpdatedEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      RocketRange.contract,
      this,
      options,
      "OpenPriceUpdated",
      fromCount
    );
  }

  subscribeClosePriceUpdatedEvent(
    options: EventSubscribeOptions<RocketRangeTypes.ClosePriceUpdatedEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      RocketRange.contract,
      this,
      options,
      "ClosePriceUpdated",
      fromCount
    );
  }

  subscribeProtocolFeeClaimedEvent(
    options: EventSubscribeOptions<RocketRangeTypes.ProtocolFeeClaimedEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      RocketRange.contract,
      this,
      options,
      "ProtocolFeeClaimed",
      fromCount
    );
  }

  subscribeNextRoundPotToppedUpEvent(
    options: EventSubscribeOptions<RocketRangeTypes.NextRoundPotToppedUpEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      RocketRange.contract,
      this,
      options,
      "NextRoundPotToppedUp",
      fromCount
    );
  }

  subscribeAllEvents(
    options: EventSubscribeOptions<
      | RocketRangeTypes.ChangeOwnerCommenceEvent
      | RocketRangeTypes.ChangeOwnerApplyEvent
      | RocketRangeTypes.MigrateCommenceEvent
      | RocketRangeTypes.MigrateApplyEvent
      | RocketRangeTypes.MigrateWithFieldsApplyEvent
      | RocketRangeTypes.NewRoundCreatedEvent
      | RocketRangeTypes.BetPlacedEvent
      | RocketRangeTypes.RoundSettledEvent
      | RocketRangeTypes.UserPayoutEvent
      | RocketRangeTypes.OpenPriceUpdatedEvent
      | RocketRangeTypes.ClosePriceUpdatedEvent
      | RocketRangeTypes.ProtocolFeeClaimedEvent
      | RocketRangeTypes.NextRoundPotToppedUpEvent
    >,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvents(
      RocketRange.contract,
      this,
      options,
      fromCount
    );
  }

  view = {
    changeOwner: async (
      params: RocketRangeTypes.CallMethodParams<"changeOwner">
    ): Promise<RocketRangeTypes.CallMethodResult<"changeOwner">> => {
      return callMethod(
        RocketRange,
        this,
        "changeOwner",
        params,
        getContractByCodeHash
      );
    },
    migrate: async (
      params: RocketRangeTypes.CallMethodParams<"migrate">
    ): Promise<RocketRangeTypes.CallMethodResult<"migrate">> => {
      return callMethod(
        RocketRange,
        this,
        "migrate",
        params,
        getContractByCodeHash
      );
    },
    changeOwnerApply: async (
      params?: RocketRangeTypes.CallMethodParams<"changeOwnerApply">
    ): Promise<RocketRangeTypes.CallMethodResult<"changeOwnerApply">> => {
      return callMethod(
        RocketRange,
        this,
        "changeOwnerApply",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    migrateApply: async (
      params?: RocketRangeTypes.CallMethodParams<"migrateApply">
    ): Promise<RocketRangeTypes.CallMethodResult<"migrateApply">> => {
      return callMethod(
        RocketRange,
        this,
        "migrateApply",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    migrateWithFieldsApply: async (
      params: RocketRangeTypes.CallMethodParams<"migrateWithFieldsApply">
    ): Promise<RocketRangeTypes.CallMethodResult<"migrateWithFieldsApply">> => {
      return callMethod(
        RocketRange,
        this,
        "migrateWithFieldsApply",
        params,
        getContractByCodeHash
      );
    },
    resetUpgrade: async (
      params?: RocketRangeTypes.CallMethodParams<"resetUpgrade">
    ): Promise<RocketRangeTypes.CallMethodResult<"resetUpgrade">> => {
      return callMethod(
        RocketRange,
        this,
        "resetUpgrade",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    getUpgradeDelay: async (
      params?: RocketRangeTypes.CallMethodParams<"getUpgradeDelay">
    ): Promise<RocketRangeTypes.CallMethodResult<"getUpgradeDelay">> => {
      return callMethod(
        RocketRange,
        this,
        "getUpgradeDelay",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    getOwner: async (
      params?: RocketRangeTypes.CallMethodParams<"getOwner">
    ): Promise<RocketRangeTypes.CallMethodResult<"getOwner">> => {
      return callMethod(
        RocketRange,
        this,
        "getOwner",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    getNewOwner: async (
      params?: RocketRangeTypes.CallMethodParams<"getNewOwner">
    ): Promise<RocketRangeTypes.CallMethodResult<"getNewOwner">> => {
      return callMethod(
        RocketRange,
        this,
        "getNewOwner",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    getUpgradeCommenced: async (
      params?: RocketRangeTypes.CallMethodParams<"getUpgradeCommenced">
    ): Promise<RocketRangeTypes.CallMethodResult<"getUpgradeCommenced">> => {
      return callMethod(
        RocketRange,
        this,
        "getUpgradeCommenced",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    getNewCode: async (
      params?: RocketRangeTypes.CallMethodParams<"getNewCode">
    ): Promise<RocketRangeTypes.CallMethodResult<"getNewCode">> => {
      return callMethod(
        RocketRange,
        this,
        "getNewCode",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    resetFields: async (
      params?: RocketRangeTypes.CallMethodParams<"resetFields">
    ): Promise<RocketRangeTypes.CallMethodResult<"resetFields">> => {
      return callMethod(
        RocketRange,
        this,
        "resetFields",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    assertOnlyOwner: async (
      params: RocketRangeTypes.CallMethodParams<"assertOnlyOwner">
    ): Promise<RocketRangeTypes.CallMethodResult<"assertOnlyOwner">> => {
      return callMethod(
        RocketRange,
        this,
        "assertOnlyOwner",
        params,
        getContractByCodeHash
      );
    },
    assertUpgradeNotPending: async (
      params?: RocketRangeTypes.CallMethodParams<"assertUpgradeNotPending">
    ): Promise<
      RocketRangeTypes.CallMethodResult<"assertUpgradeNotPending">
    > => {
      return callMethod(
        RocketRange,
        this,
        "assertUpgradeNotPending",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    assertUpgradeDelayElapsed: async (
      params?: RocketRangeTypes.CallMethodParams<"assertUpgradeDelayElapsed">
    ): Promise<
      RocketRangeTypes.CallMethodResult<"assertUpgradeDelayElapsed">
    > => {
      return callMethod(
        RocketRange,
        this,
        "assertUpgradeDelayElapsed",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    createNewRound: async (
      params?: RocketRangeTypes.CallMethodParams<"createNewRound">
    ): Promise<RocketRangeTypes.CallMethodResult<"createNewRound">> => {
      return callMethod(
        RocketRange,
        this,
        "createNewRound",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    placeBet: async (
      params: RocketRangeTypes.CallMethodParams<"placeBet">
    ): Promise<RocketRangeTypes.CallMethodResult<"placeBet">> => {
      return callMethod(
        RocketRange,
        this,
        "placeBet",
        params,
        getContractByCodeHash
      );
    },
    claimUser: async (
      params?: RocketRangeTypes.CallMethodParams<"claimUser">
    ): Promise<RocketRangeTypes.CallMethodResult<"claimUser">> => {
      return callMethod(
        RocketRange,
        this,
        "claimUser",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    settleUserBets: async (
      params: RocketRangeTypes.CallMethodParams<"settleUserBets">
    ): Promise<RocketRangeTypes.CallMethodResult<"settleUserBets">> => {
      return callMethod(
        RocketRange,
        this,
        "settleUserBets",
        params,
        getContractByCodeHash
      );
    },
    payoutUser: async (
      params: RocketRangeTypes.CallMethodParams<"payoutUser">
    ): Promise<RocketRangeTypes.CallMethodResult<"payoutUser">> => {
      return callMethod(
        RocketRange,
        this,
        "payoutUser",
        params,
        getContractByCodeHash
      );
    },
    calculateWin: async (
      params: RocketRangeTypes.CallMethodParams<"calculateWin">
    ): Promise<RocketRangeTypes.CallMethodResult<"calculateWin">> => {
      return callMethod(
        RocketRange,
        this,
        "calculateWin",
        params,
        getContractByCodeHash
      );
    },
    updateOpenPrice: async (
      params: RocketRangeTypes.CallMethodParams<"updateOpenPrice">
    ): Promise<RocketRangeTypes.CallMethodResult<"updateOpenPrice">> => {
      return callMethod(
        RocketRange,
        this,
        "updateOpenPrice",
        params,
        getContractByCodeHash
      );
    },
    setOpenPrice: async (
      params: RocketRangeTypes.CallMethodParams<"setOpenPrice">
    ): Promise<RocketRangeTypes.CallMethodResult<"setOpenPrice">> => {
      return callMethod(
        RocketRange,
        this,
        "setOpenPrice",
        params,
        getContractByCodeHash
      );
    },
    setClosePrice: async (
      params: RocketRangeTypes.CallMethodParams<"setClosePrice">
    ): Promise<RocketRangeTypes.CallMethodResult<"setClosePrice">> => {
      return callMethod(
        RocketRange,
        this,
        "setClosePrice",
        params,
        getContractByCodeHash
      );
    },
    claimProtocolFee: async (
      params?: RocketRangeTypes.CallMethodParams<"claimProtocolFee">
    ): Promise<RocketRangeTypes.CallMethodResult<"claimProtocolFee">> => {
      return callMethod(
        RocketRange,
        this,
        "claimProtocolFee",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    topUpNextRoundPot: async (
      params: RocketRangeTypes.CallMethodParams<"topUpNextRoundPot">
    ): Promise<RocketRangeTypes.CallMethodResult<"topUpNextRoundPot">> => {
      return callMethod(
        RocketRange,
        this,
        "topUpNextRoundPot",
        params,
        getContractByCodeHash
      );
    },
    updateGameSettings: async (
      params: RocketRangeTypes.CallMethodParams<"updateGameSettings">
    ): Promise<RocketRangeTypes.CallMethodResult<"updateGameSettings">> => {
      return callMethod(
        RocketRange,
        this,
        "updateGameSettings",
        params,
        getContractByCodeHash
      );
    },
    updateLeaderboard: async (
      params: RocketRangeTypes.CallMethodParams<"updateLeaderboard">
    ): Promise<RocketRangeTypes.CallMethodResult<"updateLeaderboard">> => {
      return callMethod(
        RocketRange,
        this,
        "updateLeaderboard",
        params,
        getContractByCodeHash
      );
    },
    assertPaused: async (
      params?: RocketRangeTypes.CallMethodParams<"assertPaused">
    ): Promise<RocketRangeTypes.CallMethodResult<"assertPaused">> => {
      return callMethod(
        RocketRange,
        this,
        "assertPaused",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    loadGameInstance: async (
      params: RocketRangeTypes.CallMethodParams<"loadGameInstance">
    ): Promise<RocketRangeTypes.CallMethodResult<"loadGameInstance">> => {
      return callMethod(
        RocketRange,
        this,
        "loadGameInstance",
        params,
        getContractByCodeHash
      );
    },
    loadUserBet: async (
      params: RocketRangeTypes.CallMethodParams<"loadUserBet">
    ): Promise<RocketRangeTypes.CallMethodResult<"loadUserBet">> => {
      return callMethod(
        RocketRange,
        this,
        "loadUserBet",
        params,
        getContractByCodeHash
      );
    },
  };

  transact = {
    changeOwner: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"changeOwner">
    ): Promise<RocketRangeTypes.SignExecuteMethodResult<"changeOwner">> => {
      return signExecuteMethod(RocketRange, this, "changeOwner", params);
    },
    migrate: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"migrate">
    ): Promise<RocketRangeTypes.SignExecuteMethodResult<"migrate">> => {
      return signExecuteMethod(RocketRange, this, "migrate", params);
    },
    changeOwnerApply: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"changeOwnerApply">
    ): Promise<
      RocketRangeTypes.SignExecuteMethodResult<"changeOwnerApply">
    > => {
      return signExecuteMethod(RocketRange, this, "changeOwnerApply", params);
    },
    migrateApply: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"migrateApply">
    ): Promise<RocketRangeTypes.SignExecuteMethodResult<"migrateApply">> => {
      return signExecuteMethod(RocketRange, this, "migrateApply", params);
    },
    migrateWithFieldsApply: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"migrateWithFieldsApply">
    ): Promise<
      RocketRangeTypes.SignExecuteMethodResult<"migrateWithFieldsApply">
    > => {
      return signExecuteMethod(
        RocketRange,
        this,
        "migrateWithFieldsApply",
        params
      );
    },
    resetUpgrade: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"resetUpgrade">
    ): Promise<RocketRangeTypes.SignExecuteMethodResult<"resetUpgrade">> => {
      return signExecuteMethod(RocketRange, this, "resetUpgrade", params);
    },
    getUpgradeDelay: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"getUpgradeDelay">
    ): Promise<RocketRangeTypes.SignExecuteMethodResult<"getUpgradeDelay">> => {
      return signExecuteMethod(RocketRange, this, "getUpgradeDelay", params);
    },
    getOwner: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"getOwner">
    ): Promise<RocketRangeTypes.SignExecuteMethodResult<"getOwner">> => {
      return signExecuteMethod(RocketRange, this, "getOwner", params);
    },
    getNewOwner: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"getNewOwner">
    ): Promise<RocketRangeTypes.SignExecuteMethodResult<"getNewOwner">> => {
      return signExecuteMethod(RocketRange, this, "getNewOwner", params);
    },
    getUpgradeCommenced: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"getUpgradeCommenced">
    ): Promise<
      RocketRangeTypes.SignExecuteMethodResult<"getUpgradeCommenced">
    > => {
      return signExecuteMethod(
        RocketRange,
        this,
        "getUpgradeCommenced",
        params
      );
    },
    getNewCode: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"getNewCode">
    ): Promise<RocketRangeTypes.SignExecuteMethodResult<"getNewCode">> => {
      return signExecuteMethod(RocketRange, this, "getNewCode", params);
    },
    resetFields: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"resetFields">
    ): Promise<RocketRangeTypes.SignExecuteMethodResult<"resetFields">> => {
      return signExecuteMethod(RocketRange, this, "resetFields", params);
    },
    assertOnlyOwner: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"assertOnlyOwner">
    ): Promise<RocketRangeTypes.SignExecuteMethodResult<"assertOnlyOwner">> => {
      return signExecuteMethod(RocketRange, this, "assertOnlyOwner", params);
    },
    assertUpgradeNotPending: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"assertUpgradeNotPending">
    ): Promise<
      RocketRangeTypes.SignExecuteMethodResult<"assertUpgradeNotPending">
    > => {
      return signExecuteMethod(
        RocketRange,
        this,
        "assertUpgradeNotPending",
        params
      );
    },
    assertUpgradeDelayElapsed: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"assertUpgradeDelayElapsed">
    ): Promise<
      RocketRangeTypes.SignExecuteMethodResult<"assertUpgradeDelayElapsed">
    > => {
      return signExecuteMethod(
        RocketRange,
        this,
        "assertUpgradeDelayElapsed",
        params
      );
    },
    createNewRound: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"createNewRound">
    ): Promise<RocketRangeTypes.SignExecuteMethodResult<"createNewRound">> => {
      return signExecuteMethod(RocketRange, this, "createNewRound", params);
    },
    placeBet: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"placeBet">
    ): Promise<RocketRangeTypes.SignExecuteMethodResult<"placeBet">> => {
      return signExecuteMethod(RocketRange, this, "placeBet", params);
    },
    claimUser: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"claimUser">
    ): Promise<RocketRangeTypes.SignExecuteMethodResult<"claimUser">> => {
      return signExecuteMethod(RocketRange, this, "claimUser", params);
    },
    settleUserBets: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"settleUserBets">
    ): Promise<RocketRangeTypes.SignExecuteMethodResult<"settleUserBets">> => {
      return signExecuteMethod(RocketRange, this, "settleUserBets", params);
    },
    payoutUser: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"payoutUser">
    ): Promise<RocketRangeTypes.SignExecuteMethodResult<"payoutUser">> => {
      return signExecuteMethod(RocketRange, this, "payoutUser", params);
    },
    calculateWin: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"calculateWin">
    ): Promise<RocketRangeTypes.SignExecuteMethodResult<"calculateWin">> => {
      return signExecuteMethod(RocketRange, this, "calculateWin", params);
    },
    updateOpenPrice: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"updateOpenPrice">
    ): Promise<RocketRangeTypes.SignExecuteMethodResult<"updateOpenPrice">> => {
      return signExecuteMethod(RocketRange, this, "updateOpenPrice", params);
    },
    setOpenPrice: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"setOpenPrice">
    ): Promise<RocketRangeTypes.SignExecuteMethodResult<"setOpenPrice">> => {
      return signExecuteMethod(RocketRange, this, "setOpenPrice", params);
    },
    setClosePrice: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"setClosePrice">
    ): Promise<RocketRangeTypes.SignExecuteMethodResult<"setClosePrice">> => {
      return signExecuteMethod(RocketRange, this, "setClosePrice", params);
    },
    claimProtocolFee: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"claimProtocolFee">
    ): Promise<
      RocketRangeTypes.SignExecuteMethodResult<"claimProtocolFee">
    > => {
      return signExecuteMethod(RocketRange, this, "claimProtocolFee", params);
    },
    topUpNextRoundPot: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"topUpNextRoundPot">
    ): Promise<
      RocketRangeTypes.SignExecuteMethodResult<"topUpNextRoundPot">
    > => {
      return signExecuteMethod(RocketRange, this, "topUpNextRoundPot", params);
    },
    updateGameSettings: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"updateGameSettings">
    ): Promise<
      RocketRangeTypes.SignExecuteMethodResult<"updateGameSettings">
    > => {
      return signExecuteMethod(RocketRange, this, "updateGameSettings", params);
    },
    updateLeaderboard: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"updateLeaderboard">
    ): Promise<
      RocketRangeTypes.SignExecuteMethodResult<"updateLeaderboard">
    > => {
      return signExecuteMethod(RocketRange, this, "updateLeaderboard", params);
    },
    assertPaused: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"assertPaused">
    ): Promise<RocketRangeTypes.SignExecuteMethodResult<"assertPaused">> => {
      return signExecuteMethod(RocketRange, this, "assertPaused", params);
    },
    loadGameInstance: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"loadGameInstance">
    ): Promise<
      RocketRangeTypes.SignExecuteMethodResult<"loadGameInstance">
    > => {
      return signExecuteMethod(RocketRange, this, "loadGameInstance", params);
    },
    loadUserBet: async (
      params: RocketRangeTypes.SignExecuteMethodParams<"loadUserBet">
    ): Promise<RocketRangeTypes.SignExecuteMethodResult<"loadUserBet">> => {
      return signExecuteMethod(RocketRange, this, "loadUserBet", params);
    },
  };

  async multicall<Calls extends RocketRangeTypes.MultiCallParams>(
    calls: Calls
  ): Promise<RocketRangeTypes.MultiCallResults<Calls>>;
  async multicall<Callss extends RocketRangeTypes.MultiCallParams[]>(
    callss: Narrow<Callss>
  ): Promise<RocketRangeTypes.MulticallReturnType<Callss>>;
  async multicall<
    Callss extends
      | RocketRangeTypes.MultiCallParams
      | RocketRangeTypes.MultiCallParams[]
  >(callss: Callss): Promise<unknown> {
    return await multicallMethods(
      RocketRange,
      this,
      callss,
      getContractByCodeHash
    );
  }
}
